"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformerContractType = exports.PerformerOnboardingStatus = exports.PerformerContractStatus = exports.PaymentType = void 0;
var PaymentType;
(function (PaymentType) {
    PaymentType["SessionFee"] = "Session Fee";
    PaymentType["Reuse"] = "Reuse";
    PaymentType["HoldingFee"] = "Holding Fee";
    PaymentType["Other"] = "Other";
})(PaymentType || (exports.PaymentType = PaymentType = {}));
var PerformerContractStatus;
(function (PerformerContractStatus) {
    PerformerContractStatus["Draft"] = "draft";
    PerformerContractStatus["Pending"] = "pending";
    PerformerContractStatus["Sent"] = "sent";
    PerformerContractStatus["PerformerSigned"] = "performer_signed";
    PerformerContractStatus["ProducerSigned"] = "producer_signed";
    PerformerContractStatus["Completed"] = "completed";
    PerformerContractStatus["TimeLogApproved"] = "time_log_approved";
    PerformerContractStatus["Cancelled"] = "cancelled";
    PerformerContractStatus["Declined"] = "declined";
})(PerformerContractStatus || (exports.PerformerContractStatus = PerformerContractStatus = {}));
var PerformerOnboardingStatus;
(function (PerformerOnboardingStatus) {
    PerformerOnboardingStatus["Cancelled"] = "cancelled";
    PerformerOnboardingStatus["NotStarted"] = "not_started";
    PerformerOnboardingStatus["Invited"] = "invited";
    PerformerOnboardingStatus["InvitationAccepted"] = "invitation_accepted";
    PerformerOnboardingStatus["Completed"] = "completed";
})(PerformerOnboardingStatus || (exports.PerformerOnboardingStatus = PerformerOnboardingStatus = {}));
var PerformerContractType;
(function (PerformerContractType) {
    PerformerContractType["Exhibit1"] = "Exhibit1";
    PerformerContractType["Exhibit2"] = "Exhibit2";
})(PerformerContractType || (exports.PerformerContractType = PerformerContractType = {}));
//# sourceMappingURL=performer-contract-types.js.map